module.exports = __webpack_public_path__ + "img/SimpleWealth.2477553c.png";